import React, { useEffect } from "react";
import Cookies from "universal-cookie";
import { useStore } from "./store/Store";
import { BrowserRouter, Route } from "react-router-dom";
import Header from "./components/Header";
import MainPage from "./pages/MainPage";
import {
  createMuiTheme,
  MuiThemeProvider,
  StylesProvider,
  Container,
} from "@material-ui/core";
import { getFilters } from "./restAPI/v1/filters";
import Publication from "./components/Publication";
import AlertModal from "./components/AlertModal";
import ManageKeywords from "./components/ManageKeywords";
import { decodeJWT } from "./restAPI/v1/authentication";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#91d400",
      main: "#82be00",
      dark: "#6c9e00",
      contrastText: "#fff",
    },
    secondary: {
      light: "#fea901",
      main: "#de9300",
      dark: "#bf7f00",
      contrastText: "#fff",
    },
  },
  overrides: {
    MuiButton: {
      root: { textTransform: "none" },
    },
    MuiDrawer: {
      paper: {
        background: "#555",
      },
    },
    MuiTableCell: {
      stickyHeader: {
        backgroundColor: "#eee",
        fontWeight: "bold",
        color: "#777",
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "1em",
      },
    },
    MuiSelect: {
      select: {
        color: "black",
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: "#ffd891",
      },
    },
    MuiIconButton: {
      root: {
        "&:hover": {
          backgroundColor: "rgba(238, 238, 238, 0.3)",
          borderRadius: "46px",
        },
      },
    },
    MuiListItem: {
      root: {
        "&$selected": { backgroundColor: "rgba(254, 169, 1, 0.2)" },
        "&$selected, &$selected:hover": {
          backgroundColor: "rgba(254, 169, 1, 0.2)",
        },
      },
      button: {
        transition: "background-color 0.2s",
        "&:hover": {
          textDecoration: "none",
          backgroundColor: "rgba(254, 169, 1, 0.1)",
        },
      },
    },
  },
});

function App() {
  const { dispatch } = useStore();

  useEffect(() => {
    const cookies = new Cookies();
    let jwt = cookies.get("jwt");
    async function handleJwt() {
      if (jwt) {
        decodeJWT(jwt).then(
          decoded => {
            if (decoded !== false) {
              dispatch({
                type: "SET_USER",
                user: {
                  email: decoded.email,
                  name: decoded.name,
                  phone: decoded.phone,
                  username: decoded.username,
                  groups: decoded.groups,
                  isAdmin: decoded.isAdmin,
                },
              });
            }
          }
        )
      }
      dispatch({ type: "SET_PROCESSING_COOKIE", processingCookie: false });
    }
    handleJwt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLogout = () => {
    //remove cookie and null user in state
    const cookies = new Cookies();
    cookies.remove("jwt", { path: "/", domain: ".maxiv.lu.se" });
    dispatch({
      type: "SET_USER",
      user: {
        email: "",
        name: "",
        phone: "",
        username: "",
        groups: [],
        isAdmin: false,
      },
    });
    dispatch({ type: "SET_PROCESSING_COOKIE", processingCookie: false });
  };

  const populateFilters = async () => {
    getFilters().then((data) => {
      let arr: System.Tag[] = [];
      data.forEach((tag_type: any) => {
        tag_type.tags_models.forEach((tag: any) => {
          arr.push({
            tag_type_id: tag_type.id,
            tag_type_name: tag_type.name,
            tag_name: tag.name,
            tag_id: tag.id,
          });
        });
      });
      dispatch({ type: "SET_FILTERS", filters: arr });
    });
  };
  useEffect(() => {
    populateFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <StylesProvider injectFirst>
        <Container className="MainContainer mt-3">
          <AlertModal />
          <BrowserRouter>
            <Route
              path="/"
              render={(props) => <Header onLogout={onLogout} {...props} />}
            />
            <Route exact path="/" component={MainPage} />
            <Route
              exact
              path="/publication/*"
              render={(props) => <Publication {...props} />}
            />
            <Route
              exact
              path="/manage-keywords"
              render={(props) => (
                <ManageKeywords populateFilters={populateFilters} {...props} />
              )}
            />
          </BrowserRouter>
        </Container>
      </StylesProvider>
    </MuiThemeProvider>
  );
}

export default App;
